import { render, staticRenderFns } from "./SelectBtnField.vue?vue&type=template&id=2fde67fc&scoped=true"
import script from "./SelectBtnField.vue?vue&type=script&lang=ts"
export * from "./SelectBtnField.vue?vue&type=script&lang=ts"
import style0 from "./SelectBtnField.vue?vue&type=style&index=0&id=2fde67fc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fde67fc",
  null
  
)

export default component.exports